import { dateToday, dateTwoYearsAgo } from "../../../util/billingUtils";
import * as Actions from "../../actions/billing/paymentHistoryAction";

const initialstate = {
  transactionList: [],
  actualTransactionlist: [],
  isLoading: false,
  error: false,
  paymentHistory: [],
  totalNumberOfRecords: 0,
  activePage: 0,
  recordsPerPage: 20,
  goto: "",
  filteredData: [],
  tableData: [],
  actionName: "onLoad",
  selectedfilterBy: "transactionNumber",
  slicedData: [],
  fullSearchData: [],
  dateFrom: dateTwoYearsAgo(),
  dateTo: dateToday(),
  searchOrRefresh: true,
  sortStatusInvoiceNo: "noSort",
  sortStatusTransactionNo: "noSort",
  sortStatusPaymentAmount: "noSort",
  sortStatusPaymentDate: "descending",
  sortStatusPaymentStatus: "noSort",
  sortStatusDuePaymentMode: "noSort",
  pageCount: "",
  contractAccId: "",
  showModal: false,
  loader: false,
  makePaymentHistoryCall: true,
};

export default (state = initialstate, action) => {
  switch (action.type) {
    case Actions.SET_TRANSACTION_LIST:
      return {
        ...state,
        transactionList: action.value,
      };
    case Actions.SET_ACTUAL_TRANSACTIONLIST:
      return {
        ...state,
        actualTransactionList: action.value,
      };
    case Actions.GETPAYMENTHISTORY: {
      return {
        ...state,
        isLoading: true,
        transactionList: action.value,
        actualTransactionList: action.value,
      };
    }
    case Actions.GETPAYMENTHISTORY_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        paymentHistory: action.data.data.data,
        transactionList: action.data.data.data,
        actualTransactionlist: action.data.data.data,
        activePage: 1,
        error: false,
      };
    }
    case Actions.GETPAYMENTHISTORY_FAILURE: {
      return {
        ...state,
        isLoading: false,
        paymentHistory: [],
        transactionList: [],
        actualTransactionlist: [],
        error: action.error,
      };
    }
    case Actions.MAKEPAYMENTHISTORYCALL: {
      return {
        ...state,
        makePaymentHistoryCall: action.data,
      };
    }
    case Actions.SET_TOTAL_NUMBER_OF_RECORDS_PAYMENT:
      return {
        ...state,
        totalNumberOfRecords: action.value,
      };
    case Actions.SET_ACTIVE_PAGE_PAYMENT:
      return {
        ...state,
        activePage: action.value,
      };
    case Actions.SET_SHOW_MODAL_PAYMENT:
      return {
        ...state,
        showModal: action.value,
      };
    case Actions.SET_RECORDS_PERPAGE_PAYMENT:
      return {
        ...state,
        recordsPerPage: action.value,
      };
    case Actions.SET_SLICED_DATA_PAYMENT:
      return {
        ...state,
        slicedData: action.value,
      };
    case Actions.SET_FILTERED_DATA_PAYMENT:
      return {
        ...state,
        filteredData: action.value,
      };
    case Actions.SET_TABLE_DATA_PAYMENT:
      return {
        ...state,
        tableData: action.value,
      };
    case Actions.SET_ACTION_NAME_PAYMENT:
      return {
        ...state,
        actionName: action.value,
      };

    case Actions.SET_DATE_FROM_PAYMENT:
      return {
        ...state,
        dateFrom: action.value,
      };
    case Actions.SET_DATE_TO_PAYMENT:
      return {
        ...state,
        dateTo: action.value,
      };
    case Actions.SET_SEARCH_OR_REFRESH_PAYMENT:
      return {
        ...state,
        searchOrRefresh: action.value,
      };
    case Actions.SET_SORT_STATUS_INVOICE_NO:
      return {
        ...state,
        sortStatusInvoiceNo: action.value,
      };
    case Actions.SET_SORT_STATUS_TRANSACTION_NO:
      return {
        ...state,
        sortStatusTransactionNo: action.value,
      };
    case Actions.SET_SORT_STATUS_PAYMENT_AMOUNT:
      return {
        ...state,
        sortStatusPaymentAmount: action.value,
      };
    case Actions.SET_SORT_STATUS_PAYMENT_DATE:
      return {
        ...state,
        sortStatusPaymentDate: action.value,
      };
    case Actions.SET_SORT_STATUS_PAYMENT_STATUS:
      return {
        ...state,
        sortStatusPaymentStatus: action.value,
      };
    case Actions.SET_SORT_STATUS_PAYMENT_MODE:
      return {
        ...state,
        sortStatusDuePaymentMode: action.value,
      };
    case Actions.SET_PAGE_COUNT_PAYMENT:
      return {
        ...state,
        pageCount: action.value,
      };
    case Actions.SET_CONTRACT_ACC_ID_PAYMENT:
      return {
        ...state,
        contractAccId: action.value,
      };
    case Actions.SET_ALERT_MODAL_PAYMENT:
      return {
        ...state,
        alertModal: action.value,
      };
    case Actions.SET_LOADER_PAYMENT:
      return {
        ...state,
        loader: action.value,
      };

    case Actions.RESET_PAYMENT_DATA:
      return initialstate;
    default:
      return state;
  }
};
